module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "darnah-flood-background.82c04ab6.jpg";